import { createContext } from 'react';
import type { CrmTaskInputDTO } from '../../server/dto/crm-task-input-dto.ts';
import type { AnalyticsEventPayload, LogInteractionContext } from '../analytics/types/analytics-events.ts';

/** The section a task was staged from, reported as `log_interaction_task_added`'s source. */
export type StagedTaskSource = AnalyticsEventPayload<'log_interaction_task_added'>['source'];

/** A task staged in the log interaction form — newly queued, or an edit of an existing one. */
export type TaskListItem = {
    key: string;
    values: CrmTaskInputDTO;
    assigneeName?: string;
    pending: boolean;
    onChange: (values: CrmTaskInputDTO) => void;
};

export type LogInteractionDialogContextValue = {
    /** Analytics identity of this dialog instance — every event a section sends is stamped with it. */
    session: LogInteractionContext;
    /** Always set: the sections only render once a customer is picked. */
    customerId: string;
    customerName?: string;
    stagedTasks: TaskListItem[];
    addTasks: (tasks: CrmTaskInputDTO[], source: StagedTaskSource) => void;
};

export const LogInteractionDialogContext = createContext<LogInteractionDialogContextValue | undefined>(
    undefined,
);
